import type { TransferFragment } from '../types'

export function parseFragment(hash: string): TransferFragment | null {
  const h = (hash || "").replace(/^#/, "")
  const allowed: TransferFragment[] = [
    "transfer_property",
    "transfer_resident",
    "merge_property",
    "split_property",
    "transfer_company",
  ]
  return allowed.includes(h as TransferFragment) ? (h as TransferFragment) : null
}

/** Employee tab: hide instructional blurbs for company / property / merge transfer (both sub-tabs). */
export const CONTACTS_HELPER_HIDDEN_FRAGMENTS = new Set<TransferFragment>([
  "transfer_company",
  "transfer_property",
  "merge_property",
  "split_property",
])

export function transferContactsHelpersHidden(fragment: TransferFragment | null): boolean {
  return fragment != null && CONTACTS_HELPER_HIDDEN_FRAGMENTS.has(fragment)
}
